import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { PromoBanner } from "@/components/PromoBanner";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ProductCatalog } from "@/components/ProductCatalog";
import { Reviews } from "@/components/Reviews";
import { Manifesto } from "@/components/Manifesto";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((res) => setContent(res.data))
      .catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <PromoBanner content={content?.banner} />
      <Navbar />
      <Hero content={content?.hero} />
      <Marquee content={content?.marquee} />
      <ProductCatalog />
      <Reviews />
      <Manifesto content={content?.manifesto} />
      <Footer content={content?.footer} />
      <CartDrawer />
    </div>
  );
}
